// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__PGfhC","footer":"Form_footer__1Y3Ko"};